import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2aae3482"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aae3482')) {
      api.createRecord('2aae3482', component.options)
    } else {
      api.reload('2aae3482', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2aae3482", function () {
      api.rerender('2aae3482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/categoryLabelManage/index.vue"
export default component.exports